import React from "react";
import { Link } from "react-router-dom";

import "../masterMaintenance/extraPageStyles.css";

const courseClassButton = [
  {
    name: "コース",
    path: "/admin/course-master/course-maintenance",
    icon: "fas fa-tachometer-alt",
  },
  {
    name: "コーチ",
    path: "/admin/course-master/coach-maintenance",
    icon: "fas fa-tachometer-alt",
  },
];

function BusDashboard() {
  return (
    <div className="p-3">
      <p className="headline">コース整備</p>

      <div className="btn-container col-md-4 col-sm-12">
        {courseClassButton.map(button => (
          <Link to={button.path}>
            <button className="dash-btn">{button.name}</button>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default BusDashboard;
